export default {
  data () {
    return {
      isallowedit: false
    }
  },
  methods: {
    noPermission () {
      this.$Message.warning('暂无操作权限')
    },
    desensitizedHandler (str, kind) {
      if (!str) return ''
      if (kind === 'name') {
        return str.substr(0, 1) + '*'
      }
      if (kind === 'idcard') {
        return str.replace(/^(.{6})(?:\d+)(.{4})$/, '$1********$2')
      }
      if (kind === 'phone') {
        return str.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2')
      }
      if (kind === 'mail') {
        // const email = '7385600001@qq.com'
        let email = str.split('@')
        return str[0].substr(0, email[0].length - 2) + '*****' + email[1].substr(2)
      }
      if (kind === 'number') {
        return str.replace(/(\d)/g, '*')
      }
    }
  },
  created () {
    this.isallowedit = JSON.parse(localStorage.getItem('ISEDIT'))
  }
}
